import Controller from '@ember/controller';
import type MarketSnapshotsOverviewRoute from 'lumen/routes/market/snapshots/overview';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSnapshotsOverviewController extends Controller {
  declare model: ModelFrom<MarketSnapshotsOverviewRoute>;
}
